import React, { useEffect, useState } from "react";
import $ from "jquery";
import { BrowserRouter as Router } from "react-router-dom";
import { LinkProvider } from './LinkProvider';
import { images } from "./imagesToLoad";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AnimatedRoutes from "./AnimatedRoutes";

function App() {
  
  const [isLoading, setIsLoading] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => resolve(image);
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    if (isLoading) $("body").addClass("ovf-hidden");
    Promise.all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err);
        setIsLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isLoading) {
      $("body").removeClass("ovf-hidden");
      $("#loader").addClass("hide");
    }
  }, [isLoading]);

  return (
    <>
  
    <Router>
      <LinkProvider>
        <Header />
          <AnimatedRoutes />     
        <Footer />
      </LinkProvider>
    </Router>

      </>
  );
}

export default App;
